
import React from 'react';
import Footer from '@/components/Footer';

const Insights = () => {
  return (
    <div className="min-h-screen bg-softwhite">
      <div className="pt-32 pb-16 px-4 max-w-7xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-8">Insights & Resources</h1>
        <p className="text-xl mb-12">Expert analysis, industry trends, and actionable intelligence to inform your business decisions.</p>
        
        <div className="grid md:grid-cols-2 gap-8">
          {/* Insights would go here */}
          <div className="bg-white p-8 rounded-xl shadow-md">
            <p className="text-goldcore font-semibold mb-2">Market Analysis</p>
            <h3 className="text-2xl font-bold mb-4">2023 Business Growth Trends</h3>
            <p className="mb-4">Discover the key trends that will shape business growth in the coming year.</p>
            <p className="text-sm text-gray-500">Published: June 15, 2023</p>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-md">
            <p className="text-goldcore font-semibold mb-2">Strategy</p>
            <h3 className="text-2xl font-bold mb-4">Leveraging AI for Business Advantage</h3>
            <p className="mb-4">How businesses of all sizes can benefit from artificial intelligence tools.</p>
            <p className="text-sm text-gray-500">Published: May 22, 2023</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Insights;
